import { Collapse, Card, Row, Col, Input, Spin, Button } from "antd";
import { useTranslation } from "react-i18next";
import { AddonActions } from "@/components/instance/control/AddonActions";
import { List } from "@refinedev/antd";
import { useEffect, useState } from "react";
import { showAddonDetail } from "@/apis/addons";

export const ViewAddon = ({ id, addonId, onBack }) => {
  const { t } = useTranslation();
  const { Panel } = Collapse; 
  const { TextArea } = Input;
  const [isLoading, setIsLoading] = useState(false);
  const [addon, setAddon] = useState({});
  useEffect(() => {
    const getAddon = async () => {
      try {
        setIsLoading(true);
        const result = await showAddonDetail(id, addonId);
        if("OK" == result.status && result.value) {
          setAddon(result.value.addon);
        }
      } catch (error) {
        console.error("get built-in users failed:", error);
      } finally {
        setIsLoading(false);
      }
    };
    getAddon();
  }, [id, addonId]);

  return isLoading ? ( 
    <Spin size="large" />
  ) : (
    <div>
      <List 
        breadcrumb=""
        title={addon.name}
        headerButtons={[]
        }>
          <Card>
            <Collapse
              bordered={false}
              defaultActiveKey={['1']}
              >
              <Panel header="Add-on Details" key="1">
                <Row gutter={[16, 8]} justify="space-between">  
                  <Col span={6}>  
                    <Row gutter={[8, 0]}>  
                      
                      <Col><span>Catetory</span><br /><span><strong>{addon.category}</strong></span></Col>  
                    </Row>  
                  </Col>  
                  <Col span={6}>  
                    <Row gutter={[8, 0]}>  
                      
                      <Col><span>Version</span><br /><span><strong>{addon.version}</strong></span></Col>  
                    </Row>  
                  </Col>  
                  <Col span={6}>  
                    <Row gutter={[8, 0]}>  
                      
                      <Col><span>Status</span><br /><span><strong>{addon.status}</strong></span></Col>  
                    </Row>  
                  </Col>  
                  <Col span={6}>  
                    <Row gutter={[8, 0]}>  
                      
                      <Col><span>Created</span><br /><span><strong>{addon.created_on}</strong></span></Col>  
                    </Row>  
                  </Col>  
                </Row> 
              </Panel>
            </Collapse>
          </Card>  

          <Card>
            <Collapse
              bordered={false}
              defaultActiveKey={['1']}
              >
              <Panel header="Advanced Configuration" key="1">
                <TextArea readOnly rows={8} value={addon.config}/>
              </Panel>
            </Collapse>
          </Card>
          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px' }}>
            <Button type="primary" onClick={() => {
              onBack && onBack("");
            }}>
              Back
            </Button>
          </div> 
      </List>
    </div>
    
  );
};
